<script>
import TableTemp from "../tableTemp/index.vue"
let createEl;

const text_warning = `
你目前还未进行任何催收操作，请尽快处理
当你产生第一条催收记录时，改案件会自动移入“跟进中”事件
`;

const buttons = [
  { value: "", label: '发送函件通知' },
  { value: "", label: '发送催收短信' },
  { value: "", label: '录入电话催记' },
  { value: "", label: '生成还款码' },
  { value: "", label: '请求更新还款细明' },
];

function createNav(self) {
  return buttons.map((item, index) => createEl('el-button', { 
    class: `dhx__nav-btn d-s-c d-r mr10 mb5`,
    props: { size: 'mini'},
    on: { click: () => {} },
  }, item.label));
}

function render(create) {
  createEl = create;
  return createEl('div', {
    style: { width: '100%' }
  }, [
    createEl(TableTemp, {
      props: { list: [
        { label: 'key1-1', value: 'value' },
        { label: 'key1-2', value: 'value' },
        { label: 'key1-3', value: 'value' },
        { label: 'key1-4', value: 'value' },
      ]}
    }), 
    createEl('div', { class: 'dhx__grid_line' }),
    createEl('nav', {
      class: 'dhx__nav d-s-c d-r',
    }, createNav(self)),
    createEl('div', {
      class: 'd-c-c d-c',
      style: { 
        minHeight: '100px',
        textAlign: 'center',
        whiteSpace: 'pre'
      }
    }, [
      createEl('i', { class: 'icon-null' }),
      text_warning]),
  ]);
}

export default {
  components: { TableTemp },
  render
}
</script>
<style lang="scss" scoped>
.dhx__nav {
  flex-wrap: wrap;
}
.dhx__grid_line {
  width: 100%;
  margin: 20px 0;
  border-top: solid 1px #eee;
}
.dhx__nav-btn {
  margin-left: 0;
  margin-right: 10px;
}
.icon-null {
  height: 7rem;
  aspect-ratio: 1/1;
  color: var(--theme-font-color);
  background-image: url(../../../../assets/icons/null.svg);
  background-repeat: no-repeat;
  background-size: contain;
}
.mb5 { margin-bottom: 5px; }
</style>


// WEBPACK FOOTER //
// src/views/collection/manage/sectionRight/index.vue